import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const FooterContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2.125rem 1.25rem;
    }
`

export const Container = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${props => props.theme.style.alignItems.center};
    padding: 1.875rem 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1.875rem 0 6.125rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex-direction: ${props => props.theme.style.flexDirection.row};
        justify-content: ${props => props.theme.style.justifyContent.spaceBetween};
        padding: 0;
        margin: 0 auto;
        max-width: 1110px;
    }
`

export const LinksContainer = styled.div`
    margin-top: 1.25rem;
    width: 68.125%;
    font-weight: 300;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: unset;
        flex: 1 1 auto;
        margin: 0;
    }
`

export const LinksContent = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    justify-content: ${props => props.theme.style.justifyContent.spaceEvenly};
    flex-wrap: ${props => props.theme.style.flexWrap.wrap};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        justify-content: ${props => props.theme.style.justifyContent.center};
    }
`

export const ImageContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: ${({ theme }) => theme.style.display.flex};
        flex: 1 1 auto;
    }
`

export const ImageContent = styled.img`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        height: 40px;
    }
`
